var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0.25C8.95431 0.25 0 9.20431 0 20.25C0 31.2957 8.95431 40.25 20 40.25C31.0457 40.25 40 31.2957 40 20.25C40 9.20431 31.0457 0.25 20 0.25Z",
    fill: "#DE0909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_99_5698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4518 12.7382C26.1027 12.0873 27.1579 12.0873 27.8088 12.7382C28.4597 13.389 28.4597 14.4443 27.8088 15.0952L22.7373 20.1667L28.2724 25.7018C28.9233 26.3527 28.9233 27.4079 28.2724 28.0588C27.6216 28.7097 26.5663 28.7097 25.9154 28.0588L20.3803 22.5237L14.8452 28.0588C14.1943 28.7097 13.139 28.7097 12.4882 28.0588C11.8373 27.4079 11.8373 26.3527 12.4882 25.7018L18.0233 20.1667L12.9518 15.0952C12.3009 14.4443 12.3009 13.389 12.9518 12.7382C13.6027 12.0873 14.6579 12.0873 15.3088 12.7382L20.3803 17.8096L25.4518 12.7382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.25C31.0457 0.25 40 9.20431 40 20.25C40 31.2957 31.0457 40.25 20 40.25V0.25Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_5698",
    x: 12,
    y: 12.25,
    width: 18.7606,
    height: 17.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_5698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_5698",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalReject);
export default __webpack_public_path__ + "static/media/approval_reject.59832046ef7a7bc62b09dae7ecb87e71.svg";
export { ForwardRef as ReactComponent };